import { Injectable } from "@angular/core";
import { Http, Headers, Response, RequestOptions } from "@angular/http";
import { Observable } from "rxjs";
import "rxjs/add/operator/map";
import "rxjs/add/operator/catch";
import { AuthenticationService } from "../../authentication.service";
import { EnvironmentService } from "../../index";
import { Dealer } from "app/_models/dealer";
import { UsedCarAgreement } from "app/_models/used-cars/usedcaragreement";

@Injectable()
export class UsedCarAgreementService {
  private baseUrl: string =
    this.environmentService.getBaseURL() +
    "/api" +
    "/matrix/products/used-cars/agreements";

  constructor(
    private http: Http,
    private authenticationService: AuthenticationService,
    private environmentService: EnvironmentService
  ) {}

  getByDealer(dealer_id: string): Observable<UsedCarAgreement[]> {
    let agreement$ = this.http
      .get(`${this.baseUrl}/dealer/${dealer_id}`, this.makeHeaders())
      .map(mapAgreement)
      .catch(handleError);
    return agreement$;
  }

  get(id: string): Observable<UsedCarAgreement> {
    let agreement$ = this.http
      .get(`${this.baseUrl}/${id}`, this.makeHeaders())
      .map(mapAgreement)
      .catch(handleError);
    return agreement$;
  }

  create(agreement: Partial<UsedCarAgreement>, payMonths: number): Observable<UsedCarAgreement> {
    const segmentId = 214;
    let newAgreement = this.http
      .post(
        `${this.baseUrl}?payMonths=${payMonths}`,
        JSON.stringify({ segmentId, agreement }),
        this.makeHeaders()
      )
      .map(mapAgreement)
      .catch(handleErrorAgreement);

    return newAgreement;
  }

  update(agreement: Partial<UsedCarAgreement>, payMonths: number): Observable<UsedCarAgreement> {
    return this.http.put(
      `${this.baseUrl}/${agreement._id}?payMonths=${payMonths}`,
      JSON.stringify({agreement}),
      this.makeHeaders()
    )
    .map(mapAgreement)
    .catch(handleErrorAgreement);
  }

  delete(id: string): Observable<Response> {
    return this.http
      .delete(`${this.baseUrl}/${id}`, this.makeHeaders())
      .map((res: Response) => res.json()) // ...and calling .json() on the response to return data
      .catch((error: any) =>
        Observable.throw(error.json().error || "Server error")
      ); //...errors if any
  }

  acceptAgreement(
    agreement: Partial<UsedCarAgreement>,
    dealer: Dealer,
    regnr: string,
    mauticId: string
  ): Observable<Response> {
    return this.http
      .put(
        `${this.baseUrl}/${agreement._id}/accept-agreement?dealer=${dealer._id}&regnr=${regnr}&mauticId=${mauticId}`,
        this.makeHeaders()
      )
      .map((res: Response) => res.json())
      .catch((error: any) =>
        Observable.throw(error.json().error || "Server error")
      );
  }

  private makeHeaders(): RequestOptions {
    let headers = new Headers();

    headers.append("Authorization", this.authenticationService.getToken());
    headers.append("Content-Type", "application/json ");
    headers.append("charset", "UTF-8 ");
    headers.append("Accept", "application/json ");

    let options = new RequestOptions({ headers: headers });
    return options;
  }
}

function toAgreement(r: any): UsedCarAgreement {
    return r as UsedCarAgreement;
}

function mapAgreement(response: Response): UsedCarAgreement {
  return toAgreement(response.json());
}

function handleError(error: any) {
  let errorMsg =
    error.message ||
    `Yikes! There was was a problem with our hyperdrive device and we couldn't retrieve your data!`;
  console.error(errorMsg);

  return Observable.throw(errorMsg);
}

function handleErrorAgreement(error: any) {
  let errorMsg =
  "Noget gik galt ved generering af en aftale";
  alert(errorMsg)
  return Observable.throw(error);
}



// WEBPACK FOOTER //
// ./src/app/_services/matrix/products/used-cars-agreement.service.ts